import React, {useRef, useCallback} from 'react';
import {NW, NE, SW, SE} from 'components/windows/resize-types.js';
import {
    setEdgesPadding,
    setEdgesSize,
    setEditorPadding,
    setZObjectSize,
    setSelectedPulledElements,
    setBulkWindowPositions,
    setWindowPosition} from 'actions/index.js';

export const useWindowResizer = ({
    ref,
    setCoords,
    sequencerEngine,
    setWindowScale,
    windowScale,
    adjust,
    updateOrdering,
    setIsResizing,
    getXY
}) => {
    let initialSize = useRef({width: 0, height: 0});
    let resizePosition = useRef({x:0, y:0});
    const resizeWindow = useCallback((direction, x, y, element) => {
        let xOffset = x - resizePosition.current.x;
        let yOffset = y - resizePosition.current.y;
        let {width, height} = initialSize.current;
        if (direction === NW) {
            setCoords({x: Math.max(0, x) , y: Math.max(0, y)});
        } else if (direction === SW) {
            y = element.y;
            yOffset *= -1;
        } else if (direction === NE) {
            xOffset *= -1;
            x = element.x;
        } else if (direction === SE) {
            xOffset *= -1;
            yOffset *= -1;
            x = undefined;
            y = undefined;
        }

        let newWidth = width - xOffset;
        let newHeight = height - yOffset;

        element.height = newHeight;
        element.width = newWidth;

        if (sequencerEngine) {
            sequencerEngine.dispatch(
                setZObjectSize(element.id, {width: newWidth, height, newHeight}));

            if (element.effect && element.effect.pad) {
                element.effect.pad.onSizeChange(newWidth, newHeight);
            }
        }
        setWindowScale({x: newWidth, y: newHeight});

        adjust(element.x, element.y);

        if (x !== undefined && y !== undefined) {
            x = Math.max(0, x);
            y = Math.max(0, y);
            setCoords({x,y});
        }
    }, [windowScale, setWindowScale, setCoords]);

    const startResizing = useCallback((type, e) => {
        e.stopPropagation();
        initialSize.current = getWindowSize();
        resizePosition.current = getXY(e);
        setIsResizing(type);
        updateOrdering();
    }, [windowScale, setIsResizing]);

    const getWindowSize = useCallback(() => {
        return {
            width: ref.current.offsetWidth,
            height: ref.current.offsetHeight
        };
    }, []);

    return {resizeWindow, startResizing};
};
